import { useMemo } from "react";
import { useUserId } from "../../../query/hooks/helpers";
import { usePayoutSettings } from "../../../query/payments/queries";
import { selectorInstantPayoutDefaultFee } from "../../../shared/selectors/selectorInstantPayoutDefaultFee";

export function useInstantPayoutFee() {
  const userId = useUserId();
  const queryPayoutSettings = usePayoutSettings(userId);
  return useMemo(
    () => selectorInstantPayoutDefaultFee(queryPayoutSettings.data),
    [queryPayoutSettings.data]
  );
}
